import React from "react"
import Section from "@components/structure/Section/Section"
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"
import PostsList from "../../blog/PostsList/PostsList"
import * as styles from "./LandingPagePosts.module.scss"

const LandingPagePosts = (props) => (
  <Section className={styles.LandingPagePosts}>
    <SiteWrapper>
      <h2 className={styles.title}>{props.title}</h2>
      <PostsList posts={props.posts} />
    </SiteWrapper>
  </Section>
)

export default LandingPagePosts
